import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ElementRef,
} from '@angular/core'
import { AuthenticationService } from '../../services/auth.service'
import { Vertical } from '../../models/Vertical'
import { ContextService } from '../../services/context.service'
import { Subscription } from 'rxjs'
import { Constants } from '../config/constants'
import { environment } from '../../../environments/environment'

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  subscription = new Subscription()
  defaultAvatarSrc = Constants.avatar || Constants.logo
  defaultLogoSrc = Constants.logo
  clientAvatarSrc = '/assets/img/brands/asset/logo.svg'
  fullScreenElement: any = document.documentElement
  fullscreenActive = false
  showMenu = false
  verticalName = 'Verticals'
  verticalSlug = null
  userData = null

  isPage(slug) {
    const url =
      window.location.hash.replace('#', '') || window.location.pathname
    return url === slug
  }

  isHome() {
    return this.isPage('/home') || this.isPage('/user')
  }

  get poi() {
    return this.context.poi
  }

  get politisLogos() {
    return environment.politis
  }

  constructor(
    private auth: AuthenticationService,
    private context: ContextService,
    private el: ElementRef,
    private changes: ChangeDetectorRef,
  ) {}

  private updateUserData() {
    const authData = this.auth.getUser()
    if (authData && authData.user) {
      this.userData = authData.user
    }
  }

  ngOnInit() {
    this.updateUserData()
    this.subscription.add(
      this.auth.changes.subscribe(() => this.updateUserData()),
    )
    this.showMenu = false
    this.subscription.add(
      this.context.$currentVertical.subscribe((vertical: Vertical) => {
        this.verticalName = vertical
          ? vertical.title
          : this.isPage('/user')
          ? 'Users'
          : 'Verticals'
        this.verticalSlug = vertical && vertical.slug
        this.showMenu = false
        this.changes.detectChanges()
      }),
    )
  }

  closeMenu = (ev) => {
    const container = this.el.nativeElement
    if (container && !container.contains(ev.target)) {
      this.showMenu = false
      window.removeEventListener('click', this.closeMenu)
    }
  }

  isMapSelected() {
    return window.location.pathname.split('/').includes('map')
  }

  get hasAggregates() {
    return this.context.hasAggregates()
  }

  canShowTwinAreas() {
    const vertical = this.context.vertical
    if (!vertical) {
      return false
    }
    const config = this.getDeliverySection('twin_areas')
    return config && vertical.delivery.type === 'retail'
  }

  canShowInsights() {
    const config = this.getDeliverySection('autoinsights')
    return config && config.active && config.alls && !this.canShowOD()
  }

  canShowCampaigns() {
    const vertical = this.context.vertical
    if (!vertical) {
      return false
    }

    return vertical.isOOH()
  }

  canShowMap() {
    const vertical = this.context.vertical
    if (!vertical) {
      return false
    }
    return vertical.id !== 'od'
  }

  canShowOD() {
    const vertical = this.context.vertical
    if (!vertical) {
      return false
    }
    return vertical.id === 'od'
  }

  canShowCharts() {
    const config = this.getDeliverySection('charts')
    return config && config.active && !this.canShowOD()
  }

  getDeliverySection(section) {
    const vertical = this.context.vertical
    if (
      vertical &&
      vertical.delivery &&
      vertical.delivery.sections &&
      vertical.delivery.sections[section]
    ) {
      return vertical.delivery.sections[section]
    }
    return null
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
    window.removeEventListener('click', this.closeMenu)
  }

  toggleMenu() {
    if (!this.showMenu) {
      window.addEventListener('click', this.closeMenu)
    }
    this.showMenu = !this.showMenu
  }

  toggleFullscreen() {
    // In order to avoid TypeScript warnings we will create any-typed variables
    const documentEl: any = document
    const elementEl: any = Element
    if (!documentEl.mozFullScreen && !documentEl.webkitFullscreenElement) {
      if (this.fullScreenElement.mozRequestFullScreen) {
        this.fullScreenElement.mozRequestFullScreen()
      } else {
        this.fullScreenElement.webkitRequestFullScreen(
          elementEl.ALLOW_KEYBOARD_INPUT,
        )
      }
      this.fullscreenActive = true
    } else {
      if (documentEl.mozCancelFullScreen) {
        documentEl.mozCancelFullScreen()
      } else {
        documentEl.webkitCancelFullScreen()
      }
      this.fullscreenActive = false
    }
  }

  setDefault() {
    this.clientAvatarSrc = this.defaultAvatarSrc
  }
}
